import $ from 'zepto';
import { DATA_VISIBILITY_CONFIG } from '../../../utils/constants/dataKeys';
import { log } from '../../../utils';
import { delayedAppearanceVisibilityManagerClass } from '../../../utils/constants/classes';

const animationVelocity = 400;

function hide($element) {
  $element
    .slideUp(animationVelocity, { withFade: true });
}
function show($element) {
  $element
    .slideDown(animationVelocity, { withFade: true });
}

const init = ($element) => {
  const visibilityConfig = $element.data(DATA_VISIBILITY_CONFIG);
  const values = {};
  let isVisible;

  const checkValues = () => {
    const shouldBeVisible = visibilityConfig.every(([id, expectedValue]) => values[id] === expectedValue);
    // check if it's the first time checking the visibility
    if (isVisible === undefined) {
      $element.removeClass(delayedAppearanceVisibilityManagerClass);

      if (!shouldBeVisible) {
        $element.css('display', 'none');
      }

      isVisible = shouldBeVisible;
      return;
    }

    // If it's already isVisible/hidden avoid unnecessary animations
    if (isVisible !== shouldBeVisible) {
      isVisible = shouldBeVisible;
      if (shouldBeVisible) {
        show($element);
      } else {
        hide($element);
      }
    }
  };

  const updateValue = (id, value) => {
    values[id] = value;

    checkValues();
  };

  /**
   * return the field with the given id, if there is none,
   * it will look for inputs with the given id as name.
   * @param {string} id
   */
  const getControl = (id) => {
    const $control = $(`#${id}`);
    if ($control.length === 1) {
      return $control;
    }

    return $(`[name=${id}]`);
  };

  /**
   * returns the value of the field or options fields
   * @param {Zepto} $control
   */
  const getControlValue = ($control) => {
    if ($control.length === 1) {
      return $control.val();
    }

    // for radio buttons or checkboxes
    return $control.filter(':checked').val();
  };

  visibilityConfig.forEach(([id]) => {
    const $control = getControl(id);

    if ($control.length === 0) {
      log.warn(`There is no field using '${id}' as id nor as name, please check the visibility config`);

      return;
    }

    updateValue(id, getControlValue($control));

    $control.on('change', () => {
      updateValue(id, getControlValue($control));
    });
  });
};

export default {
  init,
  type: 'field',
};
